import { BaseObject } from '../public_api';

export class ObservationImage extends BaseObject {
  public static readonly KEYS = {
    ID: 'image_id',
    FILE_NAME: 'filename',
    URL: 'image',
    THUMBNAIL_URL: 'image_thumbnail',
    WEBOPT_URL: 'image_webopt',
  };

  public readonly id: string;
  public readonly file: string;
  public readonly url: string;
  public readonly thumbnail: string;
  public readonly webOpt: string;

  protected constructor(sourceObject: Record<string, unknown>) {
    super(sourceObject);
    this.id = this._getString(ObservationImage.KEYS.ID);
    this.file = this._getString(ObservationImage.KEYS.FILE_NAME);
    this.url = this._getString(ObservationImage.KEYS.URL);
    this.thumbnail = this._getString(ObservationImage.KEYS.THUMBNAIL_URL);
    this.webOpt = this._getString(ObservationImage.KEYS.WEBOPT_URL);
  }
}
